import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import { feedbackActions } from '../../store/store';
import { useSelector, useDispatch } from 'react-redux';
import MuiAlert from '@mui/material/Alert';

export const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const MiSnackbar = () => {
  const dispatch = useDispatch();
  const { snackbarOpen, snackbarMessage, snackbarMessageSeverity } = useSelector(state => state.feedbackStore);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    dispatch(feedbackActions.setSnackbarOpen(false));
  };

  return (
    <Snackbar open={snackbarOpen} autoHideDuration={5000} onClose={handleClose}>
      <Alert onClose={handleClose} severity={`${snackbarMessageSeverity}`} sx={{ width: '100%' }}>
        {snackbarMessage}
      </Alert>
    </Snackbar>
  )
}